<script setup>
import { computed, defineProps } from 'vue';
import { useStore } from 'vuex';
// import moment from 'moment';

const props = defineProps({
   tracking: {
    type: Object,
    required: true
   }
});

const store = useStore();

const loading = computed(() => store.state.globals.loading);
</script>

<template>
<b-overlay :show="loading">
    <div class="p-3">
        <table class="table table-bordered table-sm table-light">
            <tbody v-if="!props.tracking.entries.length">
                <tr>
                    <th colspan="4" class="text-center">Tracking</th>
                </tr>
                <tr>
                    <td colspan="4" class="text-center">Tracking Number: {{ props.tracking.tracking_number ? props.tracking.tracking_number : 'n/a' }} </td>
                </tr>
                <tr>
                    <td colspan="4" class="text-center">Batch Number: {{ props.tracking.batch_number ? props.tracking.batch_number : 'n/a' }} </td>
                </tr>
                <tr>
                    <th class="text-center">Entry</th>
                    <th class="text-center">Date</th>
                    <th class="text-center">Updated by</th>
                    <th class="text-center">Image</th>
                </tr>
                <tr>
                    <td colspan="4" class="text-center">No entries found!</td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <th colspan="4" class="text-center">Tracking</th>
                </tr>
                <tr>
                    <td colspan="4" class="text-center">Tracking Number: {{ props.tracking.tracking_number ? props.tracking.tracking_number : 'n/a' }} </td>
                </tr>
                <tr>
                     <td colspan="4" class="text-center">Batch Number: {{ props.tracking.batch_number ? props.tracking.batch_number : 'n/a' }} </td>
                </tr>
                <tr>
                    <th class="text-center">Entry</th>
                    <th class="text-center">Date</th>
                    <th class="text-center">Updated by</th>
                    <th class="text-center">Image</th>
                </tr>
                <tr v-for="(entry, index) in props.tracking.entries" :key="index">
                    <td>{{ entry.entry ? entry.entry : 'n/a' }}</td>
                    <td>
                        {{ entry.date ? entry.date : 'n/a' }}
                        <span class="d-block" v-if="index + 1 === props.tracking.entries.length && entry.entry === 'DELIVERED'">
                            <span class="d-block">Name of Receiver: {{ entry.name_of_reciever ? entry.name_of_reciever : 'n/a'}}</span>
                            <span class="d-block">Date Received: {{ entry.date_recieved ? entry.date_recieved : 'n/a' }}</span>
                            <span class="d-block">Remarks: {{ entry.remarks ? entry.remarks : 'n/a' }}</span>
                        </span>
                        <span class="d-block" v-if="props.tracking.entries.length === index + 1 && entry.entry === 'RETURNED'">
                            <span class="d-block">Reason: {{ entry.reason ? entry.reason : 'n/a' }}</span>
                            <span class="d-block">Date Returned: {{ entry.date_returned ? entry.date_returned : 'n/a' }}</span>
                            <span class="d-block">Remarks: {{ entry.remarks ? entry.remarks : 'n/a' }}</span>
                        </span>
                    </td>
                    <td>{{ entry.updated_by ? entry.updated_by : 'n/a' }}</td>
                    <td>{{ entry.image ? entry.image : 'n/a'}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</b-overlay>
</template>

<style scoped>
.no-wrap{
  min-width: fit-content;
  width: 100px;
  white-space: nowrap;
}
th, td {
    background-color: #fff;
}
td{
  padding: 5px;
  text-align: center;
}
</style>
